<script lang="ts">
    
    import type { Board } from "../../Model/Board";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";
    import Cell from "./Cell.svelte";

    export let board: Board;

    const fontSizeFactor = 0.65;

    let cellWidth = 20;

    $: fontSize = cellWidth * fontSizeFactor;

</script>

<AspectKeeper ratio={1.2}>
    <div class="cells notranslate" style="font-size: {fontSize}px;">
        <div class="letter">B</div>
        <div class="letter" bind:clientWidth={cellWidth}>I</div>
        <div class="letter">N</div>
        <div class="letter">G</div>
        <div class="letter">O</div>
        {#each board.cells as cell}
            {#if cell}
                <Cell {cell} />
            {:else}
                <div class="empty-cell"></div>
            {/if}
        {/each}
    </div>
</AspectKeeper>

<style lang="scss">

    .cells {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: repeat(6, 1fr);
        gap: 0.8vw;
    }

    .letter {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        color: var(--color-primary);
        background-color: var(--color-secondary);
        border-radius: 1.2vmax;
        font-family: BingoNumber;
    }

    .empty-cell {
        background-image: url('/images/logo.png');
        background-size: 90% 90%;
        background-repeat: no-repeat;
        background-position: center;
    }

</style>
